var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { useDeviceWidth } from '../../ui';
import times from 'lodash/times';
import { RecoilRoot, useRecoilValue } from 'recoil';
import { useTheme } from '../hook/useTheme';
import { useGlobalStates } from '../store/useGlobalStates';
import store from 'store';
import { useDevice } from '../hook/useDevice';
export function App(input) {
    var _a = useDevice(), isTouch = _a.isTouch, isPhone = _a.isPhone;
    useEffect(function () {
        document.documentElement.classList.remove('isTouch', 'isPhone', 'isDesktop');
        if (isTouch) {
            document.documentElement.classList.add('isTouch');
        }
        if (isPhone) {
            document.documentElement.classList.add('isPhone');
        }
        if (!isTouch && !isPhone) {
            document.documentElement.classList.add('isDesktop');
        }
    }, [isTouch, isPhone]);
    return (React.createElement(RecoilRoot, null,
        React.createElement(Index, __assign({}, input))));
}
export function Index(_a) {
    var children = _a.children, theme = _a.theme;
    var globalStates = useGlobalStates();
    useTheme().useRegister(theme);
    var width = useDeviceWidth();
    useEffect(function () {
        var min = 300;
        var max = 640;
        if (width <= max) {
            var element_1 = document.createElement('style');
            var classes = times((max - min) / 10)
                .map(function (i) { return min + i * 10; })
                .filter(function (i) { return i > width; })
                .map(function (i) { return ".min-" + i + "px { grid-template-columns: 1fr !important; }"; });
            element_1.innerHTML = classes.join('');
            document.head.appendChild(element_1);
            return function () {
                document.head.removeChild(element_1);
            };
        }
    }, [width]);
    return (React.createElement(React.Fragment, null,
        globalStates.map(function (state) { return (React.createElement(SyncRecoilValue, { key: state.id, id: state.id, recoil: state.recoil })); }),
        children));
}
function SyncRecoilValue(_a) {
    var id = _a.id, recoil = _a.recoil;
    var value = useRecoilValue(recoil);
    useEffect(function () {
        store.set(id, value);
    }, [id, value]);
    return null;
}
